<script>
import { mapGetters, mapState } from "vuex";
import forms from "@/mixins/forms.js";

export default {
  name: "LegacyMyApplications",
  mixins: [forms],
  computed: {
    ...mapState([
      "formioToken",
      "studentApplications",
      "studentFormioSubmissions",
      "currentApplicationId",
      "userData",
      "currentUser",
    ]),
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  async beforeMount() {
    await this.$store.dispatch("getStudentApplications");
    this.redirectContinueApplication({ applicationId: this.$route.params.applicationId });
  },
  methods: {
    setPreviousApplicationData(submission) {
      // Setting up data
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "previousApplicationId",
        value: submission.data.data["application_id"],
      });
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "session",
        value: submission.data.data["session"],
      });
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "paidFee",
        value:
          Object.hasOwnProperty.call(submission.data.data, "applicationPaid") &&
          submission.data.data["applicationPaid"],
      });
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "applicationFee",
        value: Object.hasOwnProperty.call(submission.data.data, "applicationFee")
          ? submission.data.data["applicationFee"]
          : 0,
      });
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "transactionId",
        value: Object.hasOwnProperty.call(submission.data.data, "transactionId")
          ? submission.data.data["transactionId"]
          : "",
      });
      this.$store.commit("setPreviousApplicationIdByField", {
        handle: "submissionId",
        value: submission.data["_id"],
      });
    },
    redirectContinueApplication({ applicationId }) {
      const application = this.$store.state.studentApplications.find((each) => each.id === applicationId);
      if (!application) return;
      const {
        configuratorCompleted,
        programSession,
        programChange,
        uiVersion,
        programPageId,
        orderId,
        bulkEnrollmentId,
      } = application;
      this.$store.commit("setSelectedProgramId", programSession.salesforce_id);
      this.$store.dispatch("getProgramData", this.$apollo);
      this.$store.commit("setCurrentApplicationId", applicationId);
      this.$store.commit("setUiVersion", uiVersion);

      if (programChange.requestedChange) {
        this.setPreviousApplicationData(programChange);
      }

      if (this.formIsComplete(applicationId, uiVersion) || bulkEnrollmentId) {
        this.$router.push({
          name: "applications/landing",
          params: {
            applicationId: applicationId,
          },
        });
      } else if (!configuratorCompleted && programPageId && orderId) {
        this.$router.push({
          name: "configurator",
          params: { programPageId: programPageId, orderId: orderId },
        });
      } else if (uiVersion === "v3") {
        this.$router.push({
          name: "application-resume",
          params: {
            applicationId: applicationId,
          },
        });
      } else {
        this.$router.push({
          name: "applications/resume",
          params: {
            applicationId: applicationId,
          },
        });
      }
    },
  },
};
</script>
<template>
  <br />
</template>
